const storageNamespace = 'fal-hdyf9f429jhds85';

export function localStorageGetItem(key: string): string | null {
  return window.localStorage.getItem(`${storageNamespace}_${key}`);
}

export function localStorageSetItem(key: string, value: string): void {
  window.localStorage.setItem(`${storageNamespace}_${key}`, value);
}

export function localStorageRemoveItem(key: string): void {
  window.localStorage.removeItem(`${storageNamespace}_${key}`);
}

export function localStorageClear(): void {
  window.localStorage.clear();
}
